import React from 'react';
import {Link} from 'react-router';

// A real link, so Ctrl/Cmd + click, middle click and "Open in new tab" work.
function ProductBlock(props) {
    return (
        <Link className={"product-block"} to={props.to} onClick={props.onClick}>
            <div className={`telemetry-user-blocks telemetry-user-block-blue`}>
                <div className={`telemetry-image ${props.inner}`}>
                    <img src={props.img} alt=""/>
                </div>
                <div className="telemetry-text">
                    <h3>{props.number}</h3>
                    <p>{props.userText} <span className="user-info" data-title={props.tooltip}></span></p>
                    <span className="telemetry-up">View Dashboard</span>
                </div>
            </div>
        </Link>
    );
}

export default ProductBlock;
